/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiMetricFromJSON, ApiMetricToJSON, } from './ApiMetric';
import { ApiMetricCategoryFromJSON, ApiMetricCategoryToJSON, } from './ApiMetricCategory';
export function ApiSimpleMetricLabelFromJSON(json) {
    return ApiSimpleMetricLabelFromJSONTyped(json, false);
}
export function ApiSimpleMetricLabelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'aiDescription': !exists(json, 'aiDescription') ? undefined : json['aiDescription'],
        'aiDisabled': !exists(json, 'aiDisabled') ? undefined : json['aiDisabled'],
        'article': !exists(json, 'article') ? undefined : json['article'],
        'category': !exists(json, 'category') ? undefined : ApiMetricCategoryFromJSON(json['category']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'hasArticle': !exists(json, 'hasArticle') ? undefined : json['hasArticle'],
        'hidden': !exists(json, 'hidden') ? undefined : json['hidden'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'metric': !exists(json, 'metric') ? undefined : ApiMetricFromJSON(json['metric']),
    };
}
export function ApiSimpleMetricLabelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'aiDescription': value.aiDescription,
        'aiDisabled': value.aiDisabled,
        'article': value.article,
        'category': ApiMetricCategoryToJSON(value.category),
        'description': value.description,
        'hasArticle': value.hasArticle,
        'hidden': value.hidden,
        'label': value.label,
        'metric': ApiMetricToJSON(value.metric),
    };
}
